var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isHoliday ? 'dow-0' : ("dow-" + _vm.dow),staticStyle:{"font-size":"10px","color":"#000000"}},[_vm._v(" "+_vm._s(_vm.dateNum)+"("+_vm._s(_vm._f("jaDayFromDay")(_vm.dow))+") ")])}
var staticRenderFns = []

export { render, staticRenderFns }